// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.ad8a7fbbc54b2ddd299a4accf3042ac18515d301.js";
};